<template>
  <div class="edit-post">
    <div data-cy="delete-post-button" class="edit-post-button" @click="deletePostMode">
      <a class="edit-post-text">
        {{ $t('post.postDelete.delete') }}
      </a>
    </div>
    <modal-confirm
      @confirm="deletePost()"
      @close="closeModal()"
      :title="$t('post.postDelete.deletePost')"
      :message="$t('post.postDelete.deleteConfirmation')"
      :show-modal="showModal"
    />
  </div>
</template>
<script>
import ModalConfirm from '@/components/shared/ModalConfirm'
import { mapState } from 'vuex'

export default {
  name: 'PostDelete',
  components: { ModalConfirm },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
    },
    deletePostMode () {
      this.showModal = true
    },
    deletePost () {
      this.$store.dispatch('softDelete', this.post.id)
      this.showModal = false
    }
  },
  computed: mapState({
    userId: state => state.user.user.id
  })
}
</script>
<style scoped>
.edit-post {
  width: 100%;
  height: 100%;
}

.edit-post-button {
  padding: 4px 12px;
  width: 100%;
  height: 100%;
}

</style>
